import { getUser } from "./authService";
import http, { host } from "./httpService";

const user = getUser();

const getSupplierId = () => {
  if (user?.globalID) return user?.globalID;
  else return 0;
};

export const basicAuthHeaders = {
  Authorization: "ImpexCore TXlXYXlVc2VyOmRlbW8=",
  "Content-Type": "application/json-patch+json",
};

export const getPurchaseOrdersDetails = async (payload) => {
  return await http.get(host + "GetPurchaseOrdersDetails", {
    params: {
      PONumber: payload.PONumber,
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      PageNumber: payload.PageNumber,
      PageSize: payload.PageSize,
      SupplierId: getSupplierId(),
    },
  });
};

export const getInvoiceDetails = async (payload) => {
  return await http.get(host + "GetSupplierInvoicesDetailsNew", {
    params: {
      SupplierId: getSupplierId(),
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
    },
  });
};

export const getCompletedInvoiceDetails = async (payload) => {
  return await http.get(host + "GetPOForInvoiceCreationDetail", {
    params: {
      SupplierId: getSupplierId(),
      ...payload,
    },
  });
};

export const getWareHouseReciptDetails = async (payload) => {
  return await http.get(host + "GetWareHouseReciptDetails", {
    params: {
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      PONumber: payload.PONumber,
      RCPTNO: payload.RCPTNO,
      PageNumber: payload.PageNumber,
      PageSize: payload.PageSize,
      SupplierId: getSupplierId(),
    },
  });
};

export const getPendingSalesOrderDetails = async (payload) => {
  return await http.get(host + "GetPendingSalesOrderDetails", {
    params: {
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      PageNumber: payload.PageNumber,
      PageSize: payload.PageSize,
      SupplierId: getSupplierId(),
    },
  });
};

export const updateActionStatus = async (payload, action, FormName = "PO") => {
  return await http.put(host + "UpdateLatestAction", {
    FormName: FormName,
    Id: payload.POID,
    ActionTaken: action,
    CreatedBy: user?.userDetails.LoginId,
    CreatedById: user?.userDetails.UserId,
  });
};

export const downlaodPoDocument = async (POID) => {
  if (POID) {
    return await http.get(host + "ViewPoFile", {
      params: {
        PoId: POID,
      },
    });
  }
};

export const downlaodGRNDocument = async (ReceiptId) => {
  if (ReceiptId) {
    return await http.get(host + "ViewGRNFile", {
      params: {
        ReceiptNo: ReceiptId,
      },
    });
  }
};

export const getPOAccountInvoice = async (POID) => {
  return await http.get(host + "GetPOAccountInvoicesByPoId", {
    params: {
      PoId: POID,
    },
  });
};

export const getInvoiceFile = async (FileName) => {
  return await http.get(host + "ViewInvoiceByName", {
    params: {
      FileName: FileName,
    },
  });
};

export const getRejectedQC = async (payload) => {
  return await http.get(host + "GetRjectQc", {
    params: {
      FromDate: payload.FromDate,
      Todate: payload.ToDate,
      SupplierId: user?.globalID,
    },
  });
};

export const getPurchaseOrderlineItemsByPOID = async (POID) => {
  return await http.get(host + "GetPurchaseorderlineitemsById", {
    params: {
      PoId: POID,
    },
  });
};

export const getGRNlineItemsByReceiptId = async (ReceiptId) => {
  if (ReceiptId) {
    return await http.get(host + "GetGRNlineitemsById", {
      params: {
        ReceiptID: ReceiptId,
      },
    });
  }
};

export const getQClineItemsByReceiptId = async (ReceiptId) => {
  if (ReceiptId) {
    return await http.get(host + "GetQCLineitemsById", {
      params: {
        ReceiptID: ReceiptId,
      },
    });
  }
};
/* export const validatepartnumber = async (invoiecPayload) => {
  return await http.post(host + "ValidatePartNo", invoiecPayload);
}; */

export const insertSupplierInvoiceDoc = async (invoiecPayload) => {
  return await http.post(host + "AddSupplierInvoiceDocuments", invoiecPayload);
};

export const updateinvoicenumber = async (payload) => {
  return await http.put(host + "UpdateInvoiceNumber", {
    InvoiceId: payload.Invoicedocid,
    NewInvoiceNo: payload.newinvoicenumber,
    ModifiedBy: user?.userDetails.UserId,
  });
};

export const Sendmailinvoiceupdate = async (payload) => {
  return await http.put(
    host +
      `InvoiceUpdateEmail/?InvoiceId=${payload.Invoicedocid}&OldInvoiceNo=${payload.oldinvoicenumber}&NewInvoiceNo=${payload.newinvoicenumber}`
  );
};

export const deleteinvoice = async (payload) => {
  const config = {
    SupplierInvoiceDocumentsID: payload.InvoiceID,
    deletedBy: user?.userDetails.UserId,
    Remark: payload.remark,
  };
  return await http.delete(host + "DeleteInvoice", { data: config });
};

export const Sendmailinvoicedelete = async (payload) => {
  return await http.post(host + "GetInvoiceDeletedEmail", {
    SupplierInvoiceDocumentsID: payload.InvoiceID,
    Reason: payload.remark,
  });
};

export const getToDoItems = async () => {
  return await http.get(host + "GetImpexPortalActionLogById", {
    params: {
      UserID: user?.userDetails.UserId,
    },
  });
};

export const getNotifications = async () => {
  return await http.get(host + "GetImpexPortalNotification", {
    params: {
      UserId: user?.userDetails.UserId,
    },
  });
};

export const adminLogin = async (credentials) => {
  return await http.post(host + "AuthenticateAdm", credentials);
};

export const getUserRoleMapping = async () => {
  return await http.get(host + "GetRoleToUserMappingList", {
    params: {
      LogingId: user?.userDetails["LoginId"],
    },
  });
};

export const getUserList = async () => {
  return await http.get(host + "GetAllMasterUserList", {
    params: {
      GlobalId: user?.globalID,
    },
  });
};

export const getAllRoleList = async () => {
  return await http.get(host + "GetAllRoleList");
};

export const assignRoleToUser = async (formData) => {
  return await http.post(host + "AddRoletoUserMapping", formData);
};

export const createUser = async (formData) => {
  return await http.post(host + "AddEmployeeAdmin", formData);
};

export const getAssignedRoleList = async () => {
  return await http.get(host + "GetAllMappingRoleToUserList", {
    params: {
      GlobalId: user?.globalID,
    },
  });
};

export const updateUser = async (payload) => {
  return await http.put(host + "UpdateMasterUser", payload);
};

export const updateUserRole = async (payload) => {
  return await http.put(host + "RoletoUserMappingUpdate", payload);
};

export const deleteUser = async (payload) => {
  return await http.delete(
    host +
      `DeleteMasterUser?MuserId=${payload.MuserId}&UserId=${payload.UserId}`
  );
};

export const getBarChartData = async (payload) => {
  return await http.get(host + "GetPoDashBoardDetail", {
    params: {
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      PageNumber: payload.PageNumber,
      PageSize: payload.PageSize,
      SupplierId: getSupplierId(),
    },
  });
};

export const getDashboardCount = async (payload) => {
  return await http.get(host + "GetPoDashBoardCount", {
    params: {
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      PageNumber: payload.PageNumber,
      PageSize: payload.PageSize,
      SupplierId: getSupplierId(),
    },
  });
};

export const getSupplierInvoiceDetails = async (POID) => {
  return await http.get(host + "GetSupplierInvoiceDetailsByPoId", {
    params: {
      PoId: POID,
    },
  });
};

export const updateCargoReadyDate = async (payload) => {
  return await http.put(host + "UpdateCargoReadyDate", payload);
};

export const updateCargoDelayedDate = async (payload) => {
  return await http.put(host + "UpdateCargoDelayedDate", payload);
};

export const getSupplierList = async () => {
  return await http.get(host + "GetSupplierDetails");
};

export const resetPassword = async (payload) => {
  return await http.post(host + "ChangesPasswordByUser", payload);
};

export const passcodeRequest = async (emailID) => {
  return await http.post(
    host + "ForgotpasswordRequest",
    {
      EmailID: emailID,
    },
    {
      headers: basicAuthHeaders,
    }
  );
};

export const requestNewPassword = async (payload) => {
  return await http.post(host + "Chanageforgotpassword", payload, {
    headers: basicAuthHeaders,
  });
};

export const addEmailLog = async (payload) => {
  return await http.post(
    "https://vizio.atafreight.com/HoundCoreAPI_Development/" +
      "AddVizioEmailLog",
    payload,
    {
      headers: {
        Authorization: "CoreAPI TXlXYXlVc2VyOmRlbW8=",
        "Content-Type": "application/json-patch+json",
      },
    }
  );
};

export const newPriceChange = async (formData) => {
  return await http.post(host + "ChangePriceIntoTodo", formData);
};

export const updateToDoReadTime = async () => {
  return await http.put(
    host + `UpdateLastReadTODO?UserId=${user?.userDetails.UserId}`
  );
};

export const getTODOCount = async () => {
  return await http.get(host + "GetUserWiseTODOCount", {
    params: {
      UserId: user?.userDetails.UserId,
    },
  });
};

export const markNotificationAsRead = async (id) => {
  return await http.post(
    host +
      `InsertUserWiseTODOMapping?UserId=${user?.userDetails.UserId}&ImpexPortalActionLogId=${id}`
  );
};

export const requestQcRejectHistory = async (payload) => {
  return await http.get(host + "GetQcRejectHistory", {
    params: {
      UserId: user?.userDetails.UserId,
      FromDate: payload.FromDate,
      ToDate: payload.Todate,
    },
  });
};

export const addComment = async (payload) => {
  return await http.post(
    host +
      `InsertCommentHistory?FormName=${payload.FormName}&Id=${payload.Id}&Comment=${payload.Comment}&UserId=${user?.userDetails.UserId}&ActualCommentDate=${payload.ActualCommentDate}`
  );
};

export const getAllComments = async (payload) => {
  return await http.get(host + "GetCommentHistory", {
    params: {
      FormName: payload.FormName,
      Id: payload.Id,
    },
  });
};

export const updateProfileAvatar = async (formData) => {
  return await http.put(host + "UpdateUserLogo", formData);
};

export const addPOChange = async (poHistory) => {
  return await http.post(host + "AddPoChangeHistory", {
    _PoChangeHistory: poHistory,
    CreatedBy: user?.userDetails.UserId,
  });
};

export const addPriceChange = async (priceHistory) => {
  return await http.post(host + "AddPriceChangesHistory", {
    _PriceChangeHistory: priceHistory,
    CreatedBy: user?.userDetails.UserId,
  });
};

export const priceChangeApproval = async (approval, RequestIdentifier) => {
  return await http.put(host + "UpdatePriceChangeAcceptReject", {
    RequestIdentifier: RequestIdentifier,
    isAcceptReject: approval,
    UpdatedBy: user?.userDetails.UserId,
  });
};

export const poChangeApproval = async (approval, RequestIdentifier) => {
  return await http.put(host + "UpdatePOChangeAcceptReject", {
    RequestIdentifier: RequestIdentifier,
    isAcceptReject: approval,
    UpdatedBy: user?.userDetails.UserId,
  });
};

export const getRevisedPODetails = async (POID) => {
  return await http.get(host + "GetPOChangeHistoryNew", {
    params: {
      PoId: POID,
    },
  });
};

export const getRevisedPriceDetails = async (POID) => {
  return await http.get(host + "GetPriceChangeHistory", {
    params: {
      PoId: POID,
    },
  });
};

export const sendEmailForComment = async (POID) => {
  return await http.post(`${host}CommentEmailforPO?PoId=${POID}`);
};

export const sendPOChangeApprovalEmail = async (Identifier) => {
  return await http.post(
    `${host}AcceptRejectPOChangeEmail?RequestIdentifier=${Identifier}`
  );
};

export const sendPriceChangeApprovalEmail = async (Identifier) => {
  return await http.post(
    `${host}AcceptRejectPriceChangeEmail?RequestIdentifier=${Identifier}`
  );
};

export const sendInvoiceCreatedEmail = async (POID, InvoiceNo) => {
  return await http.post(
    `${host}InvoiceCreatedEmail?POID=${POID}&InvoiceNo=${InvoiceNo}`
  );
};

export const informCargoDelayMail = async (payload) => {
  return await http.post(host + "SendMailCargoDelayedDate", payload);
};

export const informCargoReadyMail = async (payload) => {
  return await http.post(host + "SendMailCargoReadyDate", payload);
};

export const sendWrongInvAmtNotification = async (payload) => {
  return await http.post(host + "AddInvoiceWarningNotification", payload);
};

export const getCCMailFromDB = async (payload) => {
  return await http.get(host + "GetToMailCCMail", payload);
};

export const handleUserTermsCondition = async (userID, token) => {
  return await http.put(
    host + `UpdateTermAndConditionFlag?UserId=${userID}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const shouldMailSendToSupplier = async (POID) => {
  const response = await http.get(host + "CheckMailSendToSupplierExists", {
    params: {
      POID,
    },
  });
  return response.data;
};
